var PopManager = /** @class */ (function () {
    function PopManager() {
    }
    // tslint:disable-next-line:no-any
    PopManager.prototype.open = function (pop) {
        if (this.currentPop && this.currentPop !== pop) {
            this.currentPop.close();
        }
        this.currentPop = pop;
    };
    // tslint:disable-next-line:no-any
    PopManager.prototype.close = function (pop) {
        if (this.currentPop === pop) {
            delete this.currentPop;
        }
    };
    // tslint:disable-next-line:no-any
    PopManager.prototype.destroy = function (pop) {
        this.close(pop);
    };
    Object.defineProperty(PopManager.prototype, "top", {
        get: function () {
            return this.currentPop;
        },
        enumerable: true,
        configurable: true
    });
    return PopManager;
}());
export default PopManager;
//# sourceMappingURL=PopManager.js.map